import { useLocation, useNavigate } from 'react-router-dom';



import { MenuProps, Tooltip } from 'antd';
import { observer } from 'mobx-react';



import { UserResp } from '@api/responseModels/user/userResponse';
import ConfirmModal from '@atoms/confirmModal/ConfirmModal';
import { NotificationButton } from '@atoms/notificationButton/notificationButton';
import { CRMAPIManager } from '@classes/crmApiManager';
import { GlobalConstants } from '@constants/global';
import { Permissions } from '@constants/permissions';
import { LoginAsOptions } from '@enums/loginAsOptions';
import { faArrowRightFromBracket, faBarcode, faBell, faBookOpen, faBriefcase, faCalendar, faComments, faContactBook, faDollar, faGear, faHouse, faList, faPersonRunning, faPlug, faScrewdriverWrench, faShoppingCart, faTableList, faUserTie, faUsers, faUsersGear } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AppFooter from '@molecules/appFooter/appFooter';
import { SecurityStore } from '@organisms/security/securityStore';
import { TAB_ROUTES } from '@organisms/workers/common/constants';
import { rootStore } from '@store/rootStore/instanse';
import { useQueryClient } from '@tanstack/react-query';
import { imagePicker } from '@utils/imagePicker';



import { SettingsManager } from '../../../classes/settingsManager';


const ApelsinFooter = observer((): JSX.Element => {
    const navigate = useNavigate();
    const location = useLocation();
    const queryClient = useQueryClient();
    const isLk =
        location.pathname.startsWith('/lk') &&
        (!location.pathname.startsWith('/lk/worker/') ||
            location.pathname === '/lk/worker/crm/create' ||
            /^\/lk\/worker\/crm\/\d+\/site$/.test(location.pathname));

    const user = rootStore.currentUserStore.getUser;
    const image = user?.pictures?.[0] || user?.picture;

    const creds = SettingsManager.getConnectionCredentials();
    const _unconnectedItems: MenuProps['items'] = [
        {
            icon: (
                <Tooltip placement="topRight" title="Подключение">
                    <FontAwesomeIcon icon={faPlug} />
                </Tooltip>
            ),
            key: 'login',
            title: 'Подключение',
            onClick: () => navigate('/login'),
        },
        {
            disabled: !creds?.token,
            icon: <FontAwesomeIcon icon={faUserTie} />,
            key: 'personal-profile',
            onClick: () => navigate('/lk'),
            title: 'Профиль',
        },
        {
            disabled: !creds?.token,
            icon: <FontAwesomeIcon icon={faGear} />,
            key: 'personal-settings',
            onClick: () => navigate(`/lk/worker/crm/${creds.crmID}/settings`),
            title: 'Настройки',
        },
        {
            disabled: !creds?.token,
            icon: <FontAwesomeIcon icon={faArrowRightFromBracket} />,
            key: 'personal-logout',
            onClick: () => navigate('/logout'),
            title: 'Закрыть сессию',
        },
    ];
    const _navLinksAll: MenuProps['items'] = [
        {
            disabled: !creds?.crmID || Permissions.checkPermission(Permissions.CrmTotal),
            icon: <FontAwesomeIcon icon={faHouse} />,
            key: 'crm',
            onClick: () => navigate(`/lk/worker/crm/${creds.crmID}`),
            title: 'Профиль CRM',
        },
        {
            disabled: !creds?.crmID || Permissions.checkPermission(Permissions.NotificationList),
            icon: <FontAwesomeIcon icon={faBell} />,
            key: 'notifications',
            onClick: () => navigate(`/lk/worker/crm/${creds.crmID}/notifications`),
            title: 'Уведомления',
        },
        {
            disabled: !creds?.crmID || Permissions.checkPermission(Permissions.WorkerPositionList),
            icon: <FontAwesomeIcon icon={faUsersGear} />,
            key: 'workers',
            onClick: () => {
                const lastPath = rootStore.navigationStore.getLastPath('workers');
                if (lastPath == null || lastPath == location.pathname) {
                    navigate(`/lk/worker/crm/${creds.crmID}/workers/tabs/${TAB_ROUTES.GROUPS}`);
                } else {
                    navigate(lastPath);
                }
            },
            title: 'Сотрудники',
        },
        {
            disabled: !creds?.crmID || Permissions.checkPermission(Permissions.CustomerProfileList),
            icon: <FontAwesomeIcon icon={faUsers} />,
            key: 'customers',
            onClick: () => {
                const lastPath = rootStore.navigationStore.getLastPath('customers');
                if (lastPath == null || lastPath == location.pathname) {
                    navigate(`/lk/worker/crm/${creds.crmID}/customers`);
                } else {
                    navigate(lastPath);
                }
            },
            title: 'Клиенты',
        },
        {
            disabled: !creds?.crmID || Permissions.checkPermission(Permissions.OrderList),
            icon: <FontAwesomeIcon icon={faTableList} />,
            key: 'orders',
            onClick: () => {
                const lastPath = rootStore.navigationStore.getLastPath('orders');
                if (lastPath == null || lastPath == location.pathname) {
                    navigate(`/lk/worker/crm/${creds.crmID}/orders`);
                } else {
                    navigate(lastPath);
                }
            },
            title: 'Заказы',
        },
        {
            disabled: !creds?.crmID || Permissions.checkPermission(Permissions.OrderList),
            icon: <FontAwesomeIcon icon={faPersonRunning} />,
            key: 'tasks',
            onClick: () => {
                const lastPath = rootStore.navigationStore.getLastPath('tasks');
                if (lastPath == null || lastPath == location.pathname) {
                    navigate(`/lk/worker/crm/${creds.crmID}/tasks`);
                } else {
                    navigate(lastPath);
                }
            },
            title: 'Задачи',
        },
        {
            disabled: !creds?.crmID || Permissions.checkPermission(Permissions.ProductList),
            icon: <FontAwesomeIcon icon={faBarcode} />,
            key: 'products',
            onClick: () => {
                const lastPath = rootStore.navigationStore.getLastPath('products');
                if (lastPath == null || lastPath == location.pathname) {
                    navigate(`/lk/worker/crm/${creds.crmID}/storages`);
                } else {
                    navigate(lastPath);
                }
            },
            title: 'Товары',
        },
        {
            disabled: !creds?.crmID || Permissions.checkPermission(Permissions.ServiceList),
            icon: <FontAwesomeIcon icon={faScrewdriverWrench} />,
            key: 'services',
            onClick: () => {
                const lastPath = rootStore.navigationStore.getLastPath('services');
                if (lastPath == null || lastPath == location.pathname) {
                    navigate(`/lk/worker/crm/${creds.crmID}/services`);
                } else {
                    navigate(lastPath);
                }
            },
            title: 'Услуги',
        },
        {
            disabled: !creds?.crmID || Permissions.checkPermission(Permissions.TransactionList),
            icon: <FontAwesomeIcon icon={faDollar} />,
            key: 'transactions',
            onClick: () => navigate(`/lk/worker/crm/${creds.crmID}/transactions`),
            title: 'Транзакции',
        },
        {
            disabled: !creds?.crmID || Permissions.checkPermission(Permissions.LogList),
            icon: <FontAwesomeIcon icon={faBookOpen} />,
            key: 'logs',
            onClick: () => navigate(`/lk/worker/crm/${creds.crmID}/logs`),
            title: 'Журнал',
        },
        {
            title: 'Роли',
            disabled:
                creds?.token == null || Permissions.checkPermission(Permissions.WorkerPositionGet),
            icon: <FontAwesomeIcon icon={faBriefcase} />,
            key: 'workplace',
            onClick: async () => {
                try {
                    const resp = await queryClient.ensureQueryData({
                        queryKey: [creds.crmID],
                        queryFn: async () => {
                            const resp = await CRMAPIManager.request<UserResp>(async (api) => {
                                return await api.getCurrentUser(creds.crmID);
                            });

                            if (resp?.errorMessages) throw resp.errorMessages;

                            return resp.data.data;
                        },
                        staleTime: 1000 * 60 * 5,
                    });

                    const userId = resp.id;
                    const firstWorkerPositionId = resp.worker_positions?.[0]?.id;

                    navigate(
                        `/lk/worker/crm/${creds.crmID}/workers/${firstWorkerPositionId}/user/${userId}`
                    );
                } catch (err) {
                    console.error(err);
                }
            },
        },
        {
            key: 'personal-divider',
        },
        {
            disabled: !creds?.token,
            icon: (
                <img
                    style={{
                        borderRadius: '50%',
                        width: '100%',
                        aspectRatio: '1 / 1',
                        objectFit: 'cover',
                    }}
                    src={imagePicker({
                        picture: image,
                        noImageUrl: GlobalConstants.NoImageWorkerUrl,
                    })}
                />
            ), //<FontAwesomeIcon icon={faUserTie} />,
            key: 'personal-profile',
            onClick: () => navigate('/lk'),
            title: 'Профиль',
        },
        /*{
            disabled: !creds?.token || Permissions.checkPermission(Permissions.CrmList),
            icon: <FontAwesomeIcon icon={faGear} />,
            key: 'personal-settings',
            onClick: () => navigate(`/lk/worker/crm/${creds.crmID}/settings`),
            title: 'Настройки',
        },
        {
            icon: <FontAwesomeIcon icon={faArrowRightFromBracket} />,
            key: 'personal-logout',
            onClick: () => navigate('/logout'),
            title: 'Выйти',
        },*/
    ];

    const _navLinksLk: MenuProps['items'] = [
        {
            disabled: false,
            icon: <FontAwesomeIcon icon={faList} />,
            key: 'catalog',
            onClick: () => navigate(`/lk/catalog`),
            title: 'Каталог',
        },
        {
            disabled: false,
            icon: <NotificationButton count={1} />,
            key: 'notifications',
            onClick: () => navigate(`/lk/notifications`),
            title: 'Уведомл.',
        },
        {
            disabled: false,
            icon: <FontAwesomeIcon icon={faContactBook} />,
            key: 'contacts',
            onClick: () => navigate(`/lk/contacts`),
            title: 'Контакты',
        },
        {
            disabled: false,
            icon: <FontAwesomeIcon icon={faCalendar} />,
            key: 'events',
            onClick: () => navigate(`/lk/events`),
            title: 'События',
        },
        {
            disabled: !creds?.token,
            icon: <FontAwesomeIcon icon={faComments} />,
            key: 'chat',
            onClick: () => navigate(`/lk/chat-groups`),
            title: 'Чат',
        },
        {
            disabled: false,
            icon: <FontAwesomeIcon icon={faShoppingCart} />,
            key: 'cart',
            onClick: () => navigate(`/lk/cart`),
            title: 'Корзина',
        },
        {
            disabled: !creds?.token,
            icon: <FontAwesomeIcon icon={faGear} />,
            key: 'settings',
            onClick: () => navigate(`/lk/settings`),
            title: 'Настройки',
        },
        {
            disabled: !creds?.token,
            icon: (
                <ConfirmModal
                    trigger={<FontAwesomeIcon icon={faArrowRightFromBracket} />}
                    title="Выход"
                    content="Вы уверены, что хотите выйти?"
                    okText="Да"
                    cancelText="Отмена"
                    width={300}
                    onConfirm={() => navigate('/logout')}
                />
            ),
            key: 'logout',
            title: 'Выйти',
        },
        {
            key: 'personal-divider',
        },
        {
            disabled: !creds?.token,
            icon: (
                <img
                    style={{
                        height: '100%',
                        width: '100%',
                        objectFit: 'cover',
                    }}
                    src={imagePicker({
                        picture: image,
                        noImageUrl: GlobalConstants.NoImageWorkerUrl,
                    })}
                />
            ),
            key: 'personal-profile',
            onClick: () => navigate('/lk'),
            title: 'Профиль',
        },
    ];

    const _navLinks: MenuProps['items'] = isLk ? _navLinksLk : _navLinksAll;

    const _adminNavLinks = [
        {
            disabled: !creds?.token || Permissions.checkPermission(Permissions.CrmList),
            icon: <FontAwesomeIcon icon={faUserTie} />,
            key: 'personal-profile',
            onClick: () => {
                SecurityStore.setLoginAs(LoginAsOptions.Employee);
                navigate('/lk');
            },
            title: 'Профиль',
        },
        {
            icon: <FontAwesomeIcon icon={faArrowRightFromBracket} />,
            key: 'personal-logout',
            onClick: () => navigate('/logout'),
            title: 'Выйти',
        },
    ];

    return (
        <AppFooter
            items={
                creds?.token
                    ? SecurityStore.loginAs === 'admin'
                        ? _adminNavLinks
                        : _navLinks
                    : _unconnectedItems
            }
            mosesSpread={creds?.token ? true : false}
        />
    );
});

export { ApelsinFooter };